import { Route } from "@angular/router";
import { AdminLayoutComponent } from "@layout/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "@layout/auth-layout/auth-layout.component";
import { Page403Component } from "./sessions/page403/page403.component";
import { Page404Component } from "./sessions/page404/page404.component";
import { Page500Component } from "./sessions/page500/page500.component";
import { Role } from "@core/models/role";
import { AuthGuard } from "@core/guard/auth.guard";

export const APP_ROUTE: Route[] = [
  {
    path: "",
    redirectTo: "/auth/login",
    pathMatch: "full",
  },
  {
    path: "admin",
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      // Admin menu start
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../modules/admin/dashboard/dashboard.routes").then(
            (m) => m.DASHBOARD_ROUTE
          ),
        data: {
          // role: [Role.Admin],
        },
      },
      {
        path: "administration",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../modules/administration/administration.routes").then(
            (m) => m.ADMINISTRATION_ROUTE
          ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "customers",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../modules/admin/customer/customer.routes").then(
            (m) => m.CUSTOMER_ROUTE
          ),
        data: {
          role: [Role.Admin],
        },
      },
      {
        path: "services",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("../modules/services/service.routes").then(
                (m) => m.SERVICE_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "inventaire",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("./equipementLayout/inventaire.routes").then(
                (m) => m.INVENTAIRE_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL, Role.ADMIN_APPART_HOTEL],
        },
      },
      {
        path: "bookings",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../modules/bookings/bookings.routes").then(
            (m) => m.BOOKING_ROUTE
          ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "finances",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("../modules/finance/finance.routes").then(
                (m) => m.FINANCE_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "operations",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("../modules/operations/operations.routes").then(
            (m) => m.OPERATIONS_ROUTE
          ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "utilities",
        loadChildren: () =>
          import("./utilities/utilities.routes").then((m) => m.UTILITIES_ROUTE),
        data: {
          role: [Role.Admin],
        },
      },
      {
        path: "services",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("../modules/services/service.routes").then(
                (m) => m.SERVICE_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "checkouts",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("../modules/reservations/components/checkout/checkout.routes").then(
                (m) => m.CHECKOUTS_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "settings",
        canActivate: [AuthGuard],
        loadChildren: () =>
            import("../modules/settings/settings.routes").then(
                (m) => m.SETTINGS_ROUTE
            ),
        data: {
          role: [Role.Admin, Role.ADMIN_GROUP_HOTEL, Role.ADMIN_HOTEL],
        },
      },
      {
        path: "403",
        component: Page403Component,
      },
      {
        path: "404",
        component: Page404Component,
      },
      {
        path: "500",
        component: Page500Component,
      },
    ],
  },

  {
    path: "auth",
    component: AuthLayoutComponent,
    loadChildren: () =>
      import("./sessions/sessions.routes").then((m) => m.SESSION_ROUTE),
  },
  { path: "**", redirectTo: "404" },
];
